import clsx from "clsx"

import type { RichTextSlice } from "~/api/prismic/types"
import CustomRichText from "~/components/CustomRichText"
import TailwindProseWrapper from "~/components/TailwindProseWrapper"

import { FootnoteTooltip } from "./FootnoteTooltip"

type Props = {
  slice: RichTextSlice
}

const ArticleRichText: React.FC<Props> = ({ slice }) => {
  const textSize = slice.primary.text_size

  return (
    <TailwindProseWrapper>
      <div
        className={clsx("m-auto max-w-screen-lg px-4", {
          "prose-sm": textSize === "small",
          "prose-lg": textSize === "large",
        })}
      >
        <CustomRichText
          field={slice.primary.text}
          components={{
            em: ({ key, children }) => {
              // FIXME: This is not a good way to do this.
              const text = children
                .map((child) => child.props.children?.[0]?.props?.children)
                .find(Boolean)

              if (text && /^\[\d+\]$/.test(text)) {
                const number = text.replace(/\D/g, "")

                return (
                  <FootnoteTooltip
                    key={key}
                    footnoteNumber={parseInt(number, 10)}
                  />
                )
              }

              return null
            },
          }}
        />
      </div>
    </TailwindProseWrapper>
  )
}

export default ArticleRichText
